import { Redirect, Route, Switch } from "react-router-dom";

import AdminPortal from "./components/portals/adminPortal";
import AssessmentTemplatePortal from "./components/portals/assessmentTemplatePortal";
import CreatorPortal from "./components/portals/creatorPortal";
import InvitePortal from "./components/portals/invitePortal";
import OnboardingPortal from "./components/portals/onboardingPortal";
import PartnerPortal from "./components/portals/partnerPortal";
import PatientPortal from "./components/portals/patientPortal";
import PracticePortal from "./components/portals/practicePortal";
import ProviderPortal from "./components/portals/providerPortal";

import constants from "./assets/constants";

const getOmniOrganizationPortal = awsGroup => {
  if (awsGroup === constants.userGroups.Administrator) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathAdmin}>
          <AdminPortal />
        </Route>
        <Route exact path={constants.appPaths.appPathAdminProvider}>
          <ProviderPortal />
        </Route>
        <Route exact path={constants.appPaths.appPathAdminAssessment}>
          <AssessmentTemplatePortal />
        </Route>
        <Route exact path={constants.appPaths.appPathAdminPartner}>
          <PartnerPortal />
        </Route>
        <Route exact path={constants.appPaths.appPathAdminPatient}>
          <PatientPortal />
        </Route>
        <Route exact path={constants.appPaths.appPathAdminPractice}>
          <PracticePortal />
        </Route>
        <Route exact path={constants.appPaths.appPathAdminInvite}>
          <InvitePortal />
        </Route>
        <Route render={() => <Redirect to={constants.appPaths.appPathAdmin} />} />
      </Switch>
    );
  }

  if (awsGroup === constants.userGroups.Provider) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathProvider}>
          <ProviderPortal />
        </Route>
        <Route exact path={constants.appPaths.appPathProviderPatient}>
          <PatientPortal />
        </Route>
        <Route render={() => <Redirect to={constants.appPaths.appPathProvider} />} />
      </Switch>
    );
  }

  if (awsGroup === constants.userGroups.Partner) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathPartner}>
          <PartnerPortal />
        </Route>
        <Route exact path={constants.appPaths.appPathPartnerPatient}>
          <PatientPortal />
        </Route>
        <Route render={() => <Redirect to={constants.appPaths.appPathPartner} />} />
      </Switch>
    );
  }

  if (awsGroup === constants.userGroups.Patient) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathPatient}>
          <PatientPortal />
        </Route>
        <Route render={() => <Redirect to={constants.appPaths.appPathPatient} />} />
      </Switch>
    );
  }

  if (awsGroup === constants.userGroups.Creator) {
    return (
      <Switch>
        <Route exact path={constants.appPaths.appPathCreator}>
          <CreatorPortal />
        </Route>

        <Route exact path={constants.appPaths.appPathCreatorDemoOnboarding}>
          <OnboardingPortal />
        </Route>

        <Route exact path={constants.appPaths.appPathCreatorDemoPatient}>
          <PatientPortal />
        </Route>

        {/* <Route exact path={constants.appPaths.appPathCreatorDemoTrials}>
          <TrialPortal />
        </Route> */}

        {/* <Route exact path={constants.appPaths.appPathCreatorDemoNMHA}>
          <NMHAPortal />
        </Route> */}

        <Route render={() => <Redirect to={constants.appPaths.appPathCreator} />} />
      </Switch>
    );
  }
};

export default getOmniOrganizationPortal;
